import { List } from 'antd'
import Button from 'antd-button-color'
import React, { useEffect, useState } from 'react'
import { removeTournament, getTournaments, getTournament } from '../../../shared/restClient'

const TournamentList = (props) => {
  const [tournaments, setTournaments] = useState([])

  useEffect(() => {
    setTournaments(props.tournaments)
  }, [props.tournaments])

  const handleLoad = (id) => {
    async function loadTournament () {
      const record = await getTournament(id)
      props.onSelect(record.data)
    }
    loadTournament()
  }

  const handleDelete = (id) => {
    async function listTournaments () {
      await removeTournament(id)
      const data = await getTournaments()
      setTournaments(data)
    }
    listTournaments()
  }

  return (
    <>
      <List
        itemLayout='horizontal'
        dataSource={tournaments}
        renderItem={(item) => {
          return (
            <List.Item
              actions={[
                <Button key='list-load' shape='round' onClick={() => handleLoad(item.data.uuid)} type='success'>load</Button>,
                // <Button key='list-share' shape='round' onClick={() => handleShare(item.data.uuid)} type='info'>share</Button>,
                <Button key='list-delete' shape='round' onClick={() => handleDelete(item.data.uuid)} type='danger'>delete</Button>]}
            >
              <List.Item.Meta
                title={item.data.title}
              />
            </List.Item>
          )
        }}
      />
    </>
  )
}

export default TournamentList
